import GlobalStyles from "./GlobalStyles";
import Icons, { IconsConsumer, IconsProvider, withIcons } from "./Icons";
import Svg from "./Svg";
import { IThemeProps, themes } from "./Theme";

export {
  GlobalStyles,
  Icons,
  IconsConsumer,
  IconsProvider,
  IThemeProps,
  Svg,
  themes,
  withIcons,
};
